import { render, staticRenderFns } from "./handle-table.vue?vue&type=template&id=fcdbe4fc"
import script from "./handle-table.vue?vue&type=script&lang=js"
export * from "./handle-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports